/** Progress semantics for canonical SiteAsset multipart ingestion (no network deps). */

export const SITE_ASSET_UPLOAD_PROGRESS_INITIAL = 8
export const SITE_ASSET_UPLOAD_PROGRESS_AWAITING_SERVER = 92
export const SITE_ASSET_UPLOAD_PROGRESS_DONE = 100

export function siteAssetUploadProgressFromBytes(loaded: number, total: number): number {
  if (!total || total <= 0) return SITE_ASSET_UPLOAD_PROGRESS_INITIAL
  if (loaded >= total) return SITE_ASSET_UPLOAD_PROGRESS_AWAITING_SERVER
  const span = SITE_ASSET_UPLOAD_PROGRESS_AWAITING_SERVER - SITE_ASSET_UPLOAD_PROGRESS_INITIAL - 1
  const ratio = Math.min(1, loaded / total)
  return Math.min(
    SITE_ASSET_UPLOAD_PROGRESS_AWAITING_SERVER - 1,
    Math.round(SITE_ASSET_UPLOAD_PROGRESS_INITIAL + ratio * span),
  )
}
